"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1 14.777c-1.476-.32-2.598-1.348-2.598-3.143h1.613c0 1.398 1.21 1.774 2.136 1.774 1.156 0 1.761-.524 1.761-1.223 0-.72-.7-.981-2.065-1.49l-.112-.042-.215-.081c-1.774-.672-2.863-1.223-2.863-2.756 0-1.348.863-2.333 2.343-2.64V6h2v1.153c1.496.262 2.54 1.203 2.54 3.093h-1.614c0-1.263-.914-1.694-1.895-1.694-1.075 0-1.748.484-1.748 1.143 0 .79.653 1.02 2.01 1.5l.02.006.188.067c1.667.592 3.119 1.183 3.119 2.836 0 1.36-.88 2.433-2.62 2.712V18h-2v-1.223z" }), "Currency");
//# sourceMappingURL=Currency.js.map